import React from 'react';
import V4VideoLayout from '../../../v4/V4VideoLayout';
import './shared/reportCards.css';

/**
 * ReportCardContainer - V4 Results Router
 * Simplified to V4-only display
 * 
 * V3 display system removed - all legacy report cards deleted
 * For V4 data: Shows modern V4VideoLayout with integrated video + analysis
 * For non-V4 data: Shows "not supported" message
 */
const ReportCardContainer = ({ 
  structuredData, 
  job, 
  evidenceUrl,
  className = '' 
}) => {
  // Check if V4 data
  const isV4 = structuredData?.version === 4 || 
               (Array.isArray(structuredData?.targets) && structuredData.targets.length > 0);
  
  // V4 data - render V4 display
  if (isV4) {
    return (
      <V4VideoLayout
        analysisData={structuredData}
        videoUrl={evidenceUrl}
        videoMetadata={{
          duration: job?.videoDuration,
          size: job?.videoSize,
          timestamp: job?.createdAt
        }}
        job={job}
        className={className}
      />
    );
  }

  // No data or unsupported format
  return (
    <div style={{
      padding: '60px 40px',
      textAlign: 'center',
      background: 'rgba(251, 146, 60, 0.1)',
      border: '2px solid rgba(251, 146, 60, 0.3)',
      borderRadius: '16px',
      maxWidth: '600px',
      margin: '40px auto'
    }}>
      <div style={{ fontSize: '64px', marginBottom: '24px' }}>📊</div>
      <h2 style={{ 
        color: '#fb923c', 
        marginBottom: '16px',
        fontSize: '24px',
        fontWeight: '700'
      }}>
        No Analysis Data
      </h2>
      <p style={{ 
        color: 'rgba(255, 255, 255, 0.8)', 
        marginBottom: '28px',
        fontSize: '16px',
        lineHeight: '1.6'
      }}>
        This job doesn't have analysis results yet, or the data format is not supported.
        <br />
        Try running a new V4 analysis.
      </p>
      <button 
        onClick={() => window.history.back()}
        style={{
          padding: '14px 32px',
          background: '#fb923c',
          color: 'white',
          border: 'none',
          borderRadius: '10px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '600',
          transition: 'all 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = '#f97316'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#fb923c'}
      >
        ← Back
      </button>
    </div>
  );
};

export default ReportCardContainer;
